// import { useState } from "react";
// import { ArrowUpRight } from "lucide-react";
// import {
//   FaFacebook,
//   FaInstagram,
//   FaLinkedin,
//   FaYoutube,
// } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { LOGO_URL } from "../data/navData";

// import Domestic from "./Domestic";
// import International from "./International";

// const socialIcons = [
//   {
//     id: 1,
//     icon: FaLinkedin,
//     url: "https://linkedin.com",
//     label: "LinkedIn",
//     bgColor: "#0A66C2", // LinkedIn Blue
//   },
//   {
//     id: 2,
//     icon: FaXTwitter,
//     url: "https://x.com",
//     label: "X",
//     bgColor: "#000000",
//   },
//   {
//     id: 3,
//     icon: FaFacebook,
//     url: "https://facebook.com",
//     label: "Facebook",
//     bgColor: "#1877F2", // Facebook Blue
//   },
//   {
//     id: 4,
//     icon: FaInstagram,
//     url: "https://instagram.com",
//     label: "Instagram",
//     bgColor: "#E4405F", // Instagram Pink
//   },
//   {
//     id: 5,
//     icon: FaYoutube,
//     url: "https://youtube.com",
//     label: "YouTube",
//     bgColor: "#FF0000", // YouTube Red
//   },
// ];

// const navigation = ["About Us", "International", "Knowledge", "Events"];
// const resources = ["News Room", "Annual Reports", "Careers", "Privacy Policy", "Terms of Use"];

// function OfficeViewSwitch({ view, onChange }) {
//   return (
//     <div className="inline-flex rounded-full bg-white/15 p-[3px] text-[15px] font-semibold">
//       <button
//         type="button"
//         onClick={() => onChange("domestic")}
//         className={`rounded-full px-[12px] py-[5px] transition-colors ${
//           view === "domestic" ? "bg-white text-[#c67800]" : "text-white/80 hover:text-white"
//         }`}
//       >
//         Domestic
//       </button>
//       {/* <button
//         type="button"
//         onClick={() => onChange("international")}
//         className={`rounded-full px-[12px] py-[5px] transition-colors ${
//           view === "international" ? "bg-white text-[#c67800]" : "text-white/80 hover:text-white"
//         }`}
//       >
//         International
//       </button> */}
//     </div>
//   );
// }

// export default function MainFooter() {
//   const [officeView, setOfficeView] = useState("domestic");

//   return (
//     <footer
//       id="contact"
//       className="map-location relative overflow-hidden text-white border-t-4 border-[#fdb913]"
//       style={{
//         background: "linear-gradient(to bottom, #da2128, #f7941d)",
//       }}
//     >
//       <div className="mx-auto grid w-full grid-cols-1 gap-x-8 gap-y-10 px-6 pb-[36px] pt-[60px] sm:px-8 lg:grid-cols-[354px_130px_150px_minmax(460px,1fr)] lg:items-start lg:gap-x-8 lg:gap-y-0 lg:px-10 lg:pb-[40px] lg:pt-[50px]">
//         <section className="max-lg:flex max-lg:flex-col max-lg:items-center">
//           {/* Brand Section */}
//           <div className="inline-block rounded-2xl bg-white p-[10px] shadow-xl">
//             <img src={LOGO_URL} alt="ASSOCHAM" className="h-[68px] w-auto" />
//           </div>

//           <p className="mt-4 text-[15px] leading-relaxed tracking-[-0.01em] text-white max-lg:text-center">
//             The Associated Chambers of Commerce and Industry of India &mdash; the country&apos;s oldest
//             apex chamber, serving Indian industry since 1920.
//           </p>

//           {/* Social Icons with Background */}
//           <div className="mt-8 flex gap-4 max-lg:justify-center">
//             {socialIcons.map((item) => (
//               <a
//                 key={item.id}
//                 href={item.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="group"
//                 aria-label={item.label}
//               >
//                 <div
//                   className="flex h-8 w-8 items-center justify-center rounded-full transition-all duration-200 hover:scale-110 hover:shadow-lg"
//                   style={{ backgroundColor: item.bgColor }}
//                 >
//                   <item.icon size={20} className="text-white" />
//                 </div>
//               </a>
//             ))}
//           </div>
//         </section>

//         {/* Navigate */}
//         <div>
//           <div className="mb-4 text-[17px] font-bold tracking-wider">NAVIGATE</div>
//           <ul className="space-y-2">
//             {navigation.map((q) => (
//               <li key={q}>
//                 <a
//                   href={`#${q.toLowerCase().replace(/\s+/g, "-")}`}
//                   className="group flex items-center gap-1.5 text-[15px] transition-colors hover:text-[#fdb913]"
//                 >
//                   <ArrowUpRight className="h-3 w-3 opacity-0 transition-all group-hover:opacity-100" />
//                   {q}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Resources */}
//         <div>
//           <div className="mb-4 text-[17px] font-bold tracking-wider">RESOURCES</div>
//           <ul className="space-y-2">
//             {resources.map((q) => (
//               <li key={q}>
//                 <a
//                   href="#"
//                   className="group flex items-center gap-1.5 text-[15px] transition-colors hover:text-[#fdb913]"
//                 >
//                   <ArrowUpRight className="h-3 w-3 opacity-0 transition-all group-hover:opacity-100" />
//                   {q}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Our Offices */}
//         <section className="pt-[2px]">
//           <div className="mb-4 flex flex-wrap items-center justify-end gap-3">
//             <h2 className="text-[17px] font-bold tracking-wider" style={{ width: "100%", textAlign: "center" }}>
//               OUR PRESENCE
//             </h2>
//             <OfficeViewSwitch view={officeView} onChange={setOfficeView} />
//           </div>

//           {officeView === "domestic" ? <Domestic /> : <International />}
//         </section>
//       </div>

//       <div className="border-t border-white/30 bg-[#da2128]">
//         <div className="mx-auto max-w-7xl px-6 py-4 text-center text-xs text-white/90">
//           © {new Date().getFullYear()} The Associated Chambers of Commerce and Industry of India. All Rights Reserved.
//         </div>
//       </div>
//     </footer>
//   );
// }







// new new code 




import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LOGO_URL } from "../data/navData";

import Domestic from "./Domestic";
import International from "./International";

const socialIcons = [
  {
    id: 1,
    icon: FaLinkedin,
    url: "https://www.linkedin.com/company/assochamforindia/",
    label: "LinkedIn",
    bgColor: "#0A66C2", // LinkedIn Blue
  },
  {
    id: 2,
    icon: FaXTwitter,
    url: "https://x.com/ASSOCHAM4India",
    label: "X",
    bgColor: "#000000",
  },
  {
    id: 3,
    icon: FaFacebook,
    url: "https://www.facebook.com/ASSOCHAM4Ind",
    label: "Facebook",
    bgColor: "#1877F2", // Facebook Blue
  },
  {
    id: 4,
    icon: FaInstagram,
    url: "https://www.instagram.com/assocham/",
    label: "Instagram",
    bgColor: "#E4405F", // Instagram Pink
  },
  {
    id: 5,
    icon: FaYoutube,
    url: "https://www.youtube.com/channel/UCL3mhKqDyERa1dTEXL3uP_Q",
    label: "YouTube",
    bgColor: "#FF0000", // YouTube Red
  },
];

const navigation = [
  { label: "About Us", path: "/about-us" },
  { label: "Membership", path: "/membership" },
  { label: "International", path: "/international" },
  { label: "Events", path: "/events" },
  { label: "Global Reserch", path: "/global-research" },
];

const resources = [
  // { label: "News Room", path: "/news-room" },
  { label: "Reports", path: "knowledge/reports" },
  { label: "Careers", path: "/career" },
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Annual Reports", path: "/annual-reports" },
  // { label: "Terms of Use", path: "" },
];

function OfficeViewSwitch({ view, onChange }) {
  return (
    <div className="inline-flex rounded-full bg-white/15 p-[3px] text-[15px] font-semibold">
      <button
        type="button"
        onClick={() => onChange("domestic")}
        className={`rounded-full px-[12px] py-[5px] transition-colors ${
          view === "domestic" ? "bg-white text-[#c67800]" : "text-white/80 hover:text-white"
        }`}
      >
        Domestic
      </button>
      {/* <button
        type="button"
        onClick={() => onChange("international")}
        className={`rounded-full px-[12px] py-[5px] transition-colors ${
          view === "international" ? "bg-white text-[#c67800]" : "text-white/80 hover:text-white"
        }`}
      >
        International
      </button> */}
    </div>
  );
}

export default function MainFooter() {
  const [officeView, setOfficeView] = useState("domestic");

  return (
    <footer
      id="contact"
      className="map-location relative overflow-hidden text-white border-t-4 border-[#fdb913]"
      style={{
        background: "linear-gradient(to bottom, #da2128, #f7941d)",
      }}
    >
      <div className="mx-auto grid w-full grid-cols-1 gap-x-8 gap-y-10 px-6 pb-[36px] pt-[60px] sm:px-8 lg:grid-cols-[354px_130px_150px_minmax(460px,1fr)] lg:items-start lg:gap-x-8 lg:gap-y-0 lg:px-10 lg:pb-[40px] lg:pt-[50px]">
        <section className="max-lg:flex max-lg:flex-col max-lg:items-center">
          {/* Brand Section */}
          <div className="inline-block rounded-2xl bg-white p-[10px] shadow-xl">
            <img src={LOGO_URL} alt="ASSOCHAM" className="h-[68px] w-auto" />
          </div>

          <p className="mt-4 text-[15px] leading-relaxed tracking-[-0.01em] text-white max-lg:text-center">
            The Associated Chambers of Commerce and Industry of India &mdash; the country&apos;s oldest
            apex chamber, serving Indian industry since 1920.
          </p>

          {/* Social Icons with Background */}
          <div className="mt-8 flex gap-4 max-lg:justify-center">
            {socialIcons.map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
                aria-label={item.label}
              >
                <div
                  className="flex h-8 w-8 items-center justify-center rounded-full transition-all duration-200 hover:scale-110 hover:shadow-lg"
                  style={{ backgroundColor: item.bgColor }}
                >
                  <item.icon size={20} className="text-white" />
                </div>
              </a>
            ))}
          </div>
        </section>

        {/* Navigate */}
        <div>
          <div className="mb-4 text-[17px] font-bold tracking-wider">NAVIGATE</div>
          <ul className="space-y-2">
            {navigation.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.path}
                  className="group flex items-center gap-1.5 text-[15px] transition-colors hover:text-[#fdb913]"
                >
                  <ArrowUpRight className="h-3 w-3 opacity-0 transition-all group-hover:opacity-100" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Resources */}
        <div>
          <div className="mb-4 text-[17px] font-bold tracking-wider">RESOURCES</div>
          <ul className="space-y-2">
            {resources.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.path}
                  className="group flex items-center gap-1.5 text-[15px] transition-colors hover:text-[#fdb913]"
                >
                  <ArrowUpRight className="h-3 w-3 opacity-0 transition-all group-hover:opacity-100" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Our Offices */}
        <section className="pt-[2px]">
          <div className="mb-4 flex flex-wrap items-center justify-end gap-3">
            <h2 className="text-[17px] font-bold tracking-wider" style={{ width: "100%", textAlign: "center" }}>
              OUR PRESENCE
            </h2>
            <OfficeViewSwitch view={officeView} onChange={setOfficeView} />
          </div>

          {officeView === "domestic" ? <Domestic /> : <International />}
        </section>
      </div>

      <div className="border-t border-white/30 bg-[#da2128]">
        <div className="mx-auto max-w-7xl px-6 py-4 text-center text-xs text-white/90">
          © {new Date().getFullYear()} The Associated Chambers of Commerce and Industry of India. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
